import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { useProps } from "./auth-service-tools225.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { useTabsContext } from "./auth-service-tools412.js";
import classes from "./auth-service-tools416.js";
const defaultProps = {};
const TabsPanel = factory((_props, ref) => {
  const props = useProps("TabsPanel", defaultProps, _props);
  const {
    children,
    className,
    value,
    classNames,
    styles,
    style,
    mod,
    keepMounted,
    ...others
  } = props;
  const ctx = useTabsContext();
  const active = ctx.value === value;
  const content = ctx.keepMounted || keepMounted ? children : active ? children : null;
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, { ...others,
    ...ctx.getStyles("panel", {
      className,
      classNames,
      styles,
      style: [style, !active ? {
        display: "none"
      } : void 0],
      props
    }),
    ref,
    mod: [{
      orientation: ctx.orientation
    }, mod],
    role: "tabpanel",
    id: ctx.getPanelId(value),
    "aria-labelledby": ctx.getTabId(value),
    children: content
  });
});
TabsPanel.classes = classes;
TabsPanel.displayName = "@mantine/core/TabsPanel";
export { TabsPanel };